<template>
  <section id="player-details">
    <player-select></player-select>
    <player-earnings></player-earnings>
  </section>
</template>

<style lang="scss" scoped>
#player-details {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 20px;
  font-weight: bold;
}
</style>

<script>
import PlayerSelect from "@/components/PlayerSalary/PlayerSelect";
import PlayerEarnings from "@/components/PlayerSalary/PlayerEarnings";
export default {
  components: {
    PlayerSelect,
    PlayerEarnings,
  },
  beforeMount(){
      this.$store.commit("setPlayerData");
  }
};
</script>